import * as React from 'react';

function MobileMenu(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={18}
      height={15}
      viewBox="0 0 18 15"
      data-testid="mobile-menu"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 1.25C0 .586.547 0 1.25 0h15c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25h-15C.547 2.5 0 1.953 0 1.25zM0 7.5c0-.664.547-1.25 1.25-1.25h15c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25h-15C.547 8.75 0 8.203 0 7.5zM16.25 15h-15C.547 15 0 14.453 0 13.75c0-.664.547-1.25 1.25-1.25h15c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25z"
        fill="#323232"
      />
    </svg>
  );
}

export default MobileMenu;
